import React, { ReactElement } from 'react';
import ActivitiesBlock from './ActivitiesBlock';
import SxkArticlesBlock from './SxkArticlesBlock';
import PaKryssBlock from './PaKryssBlock';
import SectionErrorBoundary from './SectionErrorBoundary';

export default function TopSection(): ReactElement {
  return (
    <SectionErrorBoundary name="TopSection" message="Kunde ej ladda nyheter">
      <section id="start-intro" className="start-section border-xl">
        <div className="section-flex content-container">
          <SxkArticlesBlock />
          <PaKryssBlock />
          <ActivitiesBlock />
        </div>
      </section>
    </SectionErrorBoundary>
  );
}
